import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Dashboard from "../../../components/dashboard/dashboard";
import AuthGuard from "../../../components/guards/AuthGuard";
import { storeDemoVisitor } from "../../../redux/slices/demoVisitors";
import { useSelector } from "react-redux";

const MainDashboard = ({ demoMode = false }) => {
  useEffect(() => {
    if (demoMode === true) {
      const isHeadless =
        navigator.webdriver ||
        /bot|crawl|spider|slurp|headless/i.test(navigator.userAgent);
      if (isHeadless) return; // skip storing

      fetch("https://ipapi.co/json/")
        .then((res) => res.json())
        .then(async (data) => {
          const payload = {
            country: data.country_name,
          };
          await storeDemoVisitor({ data: payload });
        });
    }
  }, []);

  if (demoMode === false) {
    return (
      <React.Fragment>
        <AuthGuard>
          <Helmet title="" />
          <Dashboard demoMode={demoMode} />
        </AuthGuard>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Helmet title="" />
        <Dashboard demoMode={demoMode} />
      </React.Fragment>
    );
  }
};

export default MainDashboard;
